
import React from "react";

export default function TermsConditions() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Terms & Conditions</h1>
      <p className="mb-4">Effective Date: 01/06/2025</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Using Sous</h2>
      <p className="mb-4">
        By using Sous, you agree to provide accurate information and not misuse the
        service. AI-generated recipes are informational only and should not replace
        professional advice.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Subscriptions & Payments</h2>
      <p className="mb-4">
        Sous offers paid features via Apple, Google, or Stripe. Subscriptions renew
        automatically. Promo codes are limited-use and must be validated.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Account Termination</h2>
      <p className="mb-4">
        You can delete your account at any time. We may also terminate accounts that
        breach our terms.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Intellectual Property</h2>
      <p className="mb-4">
        Recipes, designs, and features are owned by Sous. Reproduction requires
        written permission.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Limitation of Liability</h2>
      <p className="mb-4">
        Sous is provided as-is. We are not responsible for allergic reactions,
        inaccurate recipes, or outcomes from their use.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes</h2>
      <p className="mb-4">
        These terms may change. Continued use of the app means acceptance of the new terms.
      </p>
    </div>
  );
}
